import * as React from 'react';

/** A line a chart draws, as its legend names it. */
export interface AnalyticsChartSerieReport {
    /** The selected column the line draws. */
    column: string;
    /** The column's name in the legend, without the segment it may be narrowed to. */
    label: string;
    color: string;
}

/** Hears which lines each chart below draws (`null` once none), so what sits beside a chart takes
 * its colours from there rather than predicting them. */
export const AnalyticsChartSeriesContext = React.createContext<
    ((chartId: string, series: AnalyticsChartSerieReport[] | null) => void) | null
>(null);

/** Tell the {@link AnalyticsChartSeriesContext} above which lines this chart draws. */
export function useReportAnalyticsChartSeries(series: AnalyticsChartSerieReport[]) {
    const report = React.useContext(AnalyticsChartSeriesContext);
    const chartId = React.useId();
    // The caller builds the array anew on every render: the effect runs on its content.
    const signature = JSON.stringify(series);

    React.useEffect(() => {
        if (!report) {
            return;
        }

        report(chartId, JSON.parse(signature));
        return () => report(chartId, null);
    }, [report, chartId, signature]);
}
